import React from "react";
import "./StatCard.scss";

/**
 * Componente de card de estadísticas con icono, título y contador
 */
export const StatCard = ({
  icon,
  title,
  count = 0,
  className = "",
  ...props
}) => {
  return (
    <div className={`stat-card ${className}`} {...props}>
      <div className="stat-card__icon-container">{icon}</div>
      <span className="stat-card__title">{title}</span>
      <span className="stat-card__count">{count}</span>
    </div>
  );
};
